'use client';

import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';

type RichTextAnchorProps = {
  href: string;
  children: React.ReactNode;
};

export const RichTextAnchor: React.FC<RichTextAnchorProps> = ({ href, children }) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (href === '#uc-central-modal-show') {
      event.preventDefault();
      event.stopPropagation();
      window.__ucCmp?.showSecondLayer();
    }
  };

  return (
    <TextCTA as="a" href={href} inlineLink target={href.startsWith('http') ? '_blank' : '_self'} onClick={handleClick}>
      {children}
    </TextCTA>
  );
};
